import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=6ed68988&scoped=true&"
import script from "./Like.vue?vue&type=script&lang=js&"
export * from "./Like.vue?vue&type=script&lang=js&"
import style0 from "./Like.vue?vue&type=style&index=0&id=6ed68988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed68988",
  null
  
)

export default component.exports